import {Table} from "antd"

function DataTable({data,cols, perPage, totalElements, onPageChange,...rest}){
    return(
        <>
            <Table
                bordered
                columns={cols}
                rowKey={(record)=>record.id?record.id:record.key}
                dataSource={data}
                pagination={{
                    pageSize: perPage ?? 10,
                    onChange: (page, pageSize) => onPageChange && onPageChange(page, pageSize),
                    hideOnSinglePage: false,
                    total: totalElements
                }}
                {...rest}
                style={{maxWidth:"100%"}}
                scroll={{ x: 'max-content' }}
                responsive={true}
            />
        </>
    )
}
 // dataSource={data} pagination={{pageSize: perPage ?? 10, onChange: (page, pageSize) => onPageChange && onPageChange(page, pageSize), hideOnSinglePage: false, total: totalElements}} {...rest} style={{maxWidth:"100%"}}/>
 //        </>
 //    )
// }
export default DataTable;
